import {nanoid} from "nanoid"
import {getValueByActiveTab} from "../misc/utils"
import {buildDefaultEntry} from "../misc/default-registry"

const defaultsByAnswer = (alter, bisRangeLimit, geburtsjahr, von, bis) => ({
    ZEITRAUM: {
        von: geburtsjahr + von,
        bis: geburtsjahr + bis
    },
    ALTER: {
        von: von - geburtsjahr,
        bis: bis - geburtsjahr
    }
})

const familienstaende = new Set(["VERHEIRATET", "LEBENSGEMEINSCHAFT"])

export const CrossSiteActions = ({getDataFromPointer, updateData}) => {
    return {
        ADD_KIND: () => {
            const kinderList = getDataFromPointer("/kinder") ?? []
            // Die id bleibt lokal — DELETE_KIND identifiziert das Kind darueber.
            const newKind = {...buildDefaultEntry("/kinder"), id: nanoid()}
            updateData([...kinderList, newKind], "/kinder")
        },
        DELETE_KIND: (kind) => {
            const kinderList = getDataFromPointer("/kinder") ?? []
            const newList = kinderList.filter(el => el.id !== kind.payload.id)
            updateData(newList, "/kinder")
        },
        CHANGE_VIEW_TO_VERTRAEGE: () => {
            updateData("VERTRAEGE", "/appstate/kundendaten/activeView")
        },
        RESET_KUNDENDATEN_VIEW: () => {
            updateData("INIT", "/appstate/kundendaten/activeView")
        },
        SET_EHEPARTNEREINKOMMEN_ZERO: (payload) => {
            // TODO: Dieses Sideeffect wird mit https://teckpro.atlassian.net/browse/VW-1240 refactored
            if (familienstaende.has(payload.value)) {
                updateData(0, "/ehepartner/jaehrlichesBruttoEinkommen")
            }
        },
        FILTERN_NACH_CHANGE: ({value}) => {
            const zeitraum = getDataFromPointer("/appstate/zeitraum")
            const von = Number.parseInt(zeitraum?.von)
            const bis = Number.parseInt(zeitraum?.bis)
            const alterByActiveTab = getValueByActiveTab(getDataFromPointer, "alterKalenderjahr")
            const geburtsdatumByActiveTab = getValueByActiveTab(getDataFromPointer, "geburtsdatum")
            const geburtsjahr = new Date(geburtsdatumByActiveTab).getFullYear()
            const bisRangeLimit = Number.parseInt(getDataFromPointer("/constants/bis"))
            const answers = defaultsByAnswer(alterByActiveTab, bisRangeLimit, geburtsjahr, von, bis)[value]
            updateData(answers, "/appstate/zeitraum")
        },
        TAB_CHANGE: ({text}) => {
            updateData(text, "/appstate/activeTab")
        }
    }
}